// Detect when a newer build has been deployed than the one currently running,
// so the live-load Capacitor shell (and the PWA) can offer a Refresh instead of
// needing a manual force-quit. Each build bakes its commit into the bundle as
// __APP_VERSION__ AND emits a deployed version.json with the same commit; if
// they differ, a new build is live.

// The commit the running bundle was built from. `typeof` guard so this module
// is safe under vitest (where __APP_VERSION__ is not defined) and in dev.
export const RUNNING_COMMIT = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : null;

/**
 * True when the deployed version.json reports a different commit than the one
 * running. Never throws and returns false whenever the answer is unknown (no
 * commit baked in, fetch fails, malformed json), so it can never nag falsely.
 *
 * @param {string|null} running   the running build's commit (defaults to RUNNING_COMMIT)
 * @param {typeof fetch|null} fetchImpl  injectable for tests
 */
export async function isUpdateAvailable(
  running = RUNNING_COMMIT,
  fetchImpl = (typeof fetch !== 'undefined' ? fetch : null),
) {
  if (!running || running === 'unknown' || !fetchImpl) return false;
  try {
    const res = await fetchImpl('/version.json', { cache: 'no-store' });
    if (!res.ok) return false;
    const data = await res.json();
    return !!data
      && typeof data.commit === 'string'
      && data.commit !== 'unknown'
      && data.commit !== running;
  } catch {
    return false;
  }
}
